module.exports = __webpack_public_path__ + "img/39.7dd27875.jpg";